import { render, staticRenderFns } from "./AdFormats.vue?vue&type=template&id=05c2e12f"
import script from "./AdFormats.vue?vue&type=script&lang=js"
export * from "./AdFormats.vue?vue&type=script&lang=js"
import style0 from "./AdFormats.vue?vue&type=style&index=0&id=05c2e12f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports